import { useMemo } from "react";
import { useQuery } from "@apollo/client";

import { useAuthContext } from "../../../lib/context/Auth/AuthContext";

import {
  GetDateTimeDevicesResponse,
  GetDateTimeDevicesVariables,
  GET_DATE_TIME_DEVICES,
} from "../../../api/graphql/devices/devices";
import { supportsDateTimeSettings } from "./deviceDateTime";

// The account's devices that support Date & time settings. The Devices page
// filters and search don't apply: the bulk wizard works across the account.
export const useDateTimeDevices = () => {
  const { user } = useAuthContext();
  const { loading, error, data, refetch } = useQuery<
    GetDateTimeDevicesResponse,
    GetDateTimeDevicesVariables
  >(GET_DATE_TIME_DEVICES, {
    fetchPolicy: "cache-and-network",
    variables: {
      tenantId: user?.customerid || "",
    },
  });

  const devices = useMemo(
    () => (data?.queryDevice || []).filter(supportsDateTimeSettings),
    [data]
  );

  return { loading, error, devices, refetch };
};
